<template>
	<div class="ov-card">
		<div v-if="title || $slots.header" class="ov-card__header">
			<slot name="header">
				<h2 class="ov-card__title">{{ title }}</h2>
			</slot>
		</div>
		<div class="ov-card__body">
			<slot />
		</div>
	</div>
</template>

<script>
export default {
	name: "OvCard",
	props: {
		title: { type: String, default: "" },
	},
};
</script>
